import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { PermissionsService } from 'src/app/services/permissions.service';
import { SidebarSettings } from 'src/app/utils/enum/sidebar-settings';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-settings-sidenav',
    templateUrl: './settings-sidenav.component.html',
    styleUrls: ['./settings-sidenav.component.scss'],
})
export class SettingsSidenavComponent {
    readonly SidebarSettings = SidebarSettings;
    selectedComponent!: SidebarSettings;
    env = environment;
    filteredComponents: string[] = [];

    constructor(private permissionsService: PermissionsService) {
        this.filterComponents();
    }

    filterComponents() {
        this.filteredComponents = [...this.componentKeys];

        if (!this.permissionsService.hasPermission('auth-module.settings.users.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== SidebarSettings.UTILIZATORI)
        }
        if (!this.permissionsService.hasPermission('auth-module.settings.directii.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== SidebarSettings.INSTITUTII)
        }
        if (!this.permissionsService.hasPermission('auth-module.settings.compartimente.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== SidebarSettings.COMPARTIMENTE)
        }
        if (!this.permissionsService.hasPermission('auth-module.settings.functii.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== SidebarSettings.FUNCTII)
        }
        if (!this.permissionsService.hasPermission('auth-module.platform.section.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== SidebarSettings.PLATFORM_SECTION)
        }
        if (!this.permissionsService.hasPermission('auth-module.platform.faq.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== SidebarSettings.PLATFORM_FAQ)
        }
        if (!this.permissionsService.hasPermission('auth-module.platform.content.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== SidebarSettings.PLATFORM_CONTENT)
        }
        if (!this.permissionsService.hasPermission('auth-module.platform.announces.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== SidebarSettings.PLATFORM_ANNOUNCES)
        }
        if (!this.permissionsService.hasPermission('auth-module.cerere-settings.type.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== SidebarSettings.CERERE_TYPES)
        }
        if (!this.permissionsService.hasPermission('auth-module.cerere-settings.status.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== SidebarSettings.CERERE_STATUS)
        }
        if (!this.permissionsService.hasPermission('auth-module.cerere-settings.priority.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== SidebarSettings.CERERE_PRIORITY)
        }
        if (!this.permissionsService.hasPermission('auth-module.citizen-document-types.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== SidebarSettings.TIPURI_DOCUMENTE)
        }
        if (!this.permissionsService.hasPermission('auth-module.settings.countries.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== SidebarSettings.TARI)
        }
        if (!this.permissionsService.hasPermission('auth-module.settings.judete.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== SidebarSettings.JUDETE)
        }
        if (!this.permissionsService.hasPermission('auth-module.settings.localitati.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== SidebarSettings.LOCALITATI)
        }
        if (!this.permissionsService.hasPermission('auth-module.settings.strazi.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== SidebarSettings.STRAZI)
        }
    }

    componentMapping: Record<SidebarSettings, string> = {
        [SidebarSettings.UTILIZATORI]: 'app-users-setting',
        [SidebarSettings.INSTITUTII]: 'app-directii',
        [SidebarSettings.COMPARTIMENTE]: 'app-compartimente',
        // [SidebarSettings.DEPARTAMENTE]: 'app-departments-settings',
        // [SidebarSettings.CONFIGURATII]: 'app-config-settings',
        [SidebarSettings.FUNCTII]: 'app-functii',
        // [SidebarSettings.CERERE_SABLOANE]: 'app-cerere-sabloane',
        [SidebarSettings.PLATFORM_SECTION]: 'app-platform-section',
        [SidebarSettings.PLATFORM_FAQ]: 'app-platform-faq',
        [SidebarSettings.PLATFORM_CONTENT]: 'app-platform-content',
        [SidebarSettings.PLATFORM_ANNOUNCES]: 'app-platform-announces',
        [SidebarSettings.CERERE_TYPES]: 'app-cerere-type',
        [SidebarSettings.CERERE_STATUS]: 'app-cerere-status',
        [SidebarSettings.CERERE_PRIORITY]: 'app-cerere-priority',
        [SidebarSettings.TIPURI_DOCUMENTE]: 'app-tipuri-documente',
        [SidebarSettings.TARI]: 'app-tari',
        [SidebarSettings.JUDETE]: 'app-judete',
        [SidebarSettings.LOCALITATI]: 'app-localitati',
        [SidebarSettings.STRAZI]: 'app-strazi',
    };
    componentKeys: string[] = Object.keys(this.componentMapping);

    onChange($event: { value: any }) {
        this.selectedComponent = $event.value;
    }

    selectedSection: any = null;
}
